import { createSelector } from 'reselect'

import { selectLandingState } from './selectLandingState'

export const selectLandingSelectedStatus = createSelector(
  [selectLandingState],
  ({ selectedStatus }) => selectedStatus
)
